'use client';

import React from 'react';
import type { AdSlot } from '@/lib/api-client';
import { useAuth } from '@/context/AuthContext';

function ensureAbsoluteUrl(url: string): string {
  if (!url) return '#';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) return url;
  return `https://${url}`;
}

interface InFeedAdProps {
  slot?: AdSlot;
}

export default function InFeedAd({ slot }: InFeedAdProps) {
  const { isPro } = useAuth();
  if (isPro) return null;

  if (slot?.isActive && slot.imageUrl) {
    return (
      <div className="col-span-1 sm:col-span-2 lg:col-span-3 xl:col-span-4">
        <a href={ensureAbsoluteUrl(slot.targetUrl)} target="_blank" rel="noopener noreferrer" className="block">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={slot.imageUrl}
            alt={slot.altText}
            className="w-full h-24 object-cover rounded-xl"
          />
        </a>
      </div>
    );
  }

  return (
    <div className="col-span-1 sm:col-span-2 lg:col-span-3 xl:col-span-4">
      <div className="rounded-xl border border-amber-500/20 bg-amber-500/5 flex items-center justify-between px-6 py-4 gap-4">
        <div>
          <p className="text-[10px] text-amber-500/60 uppercase tracking-widest font-semibold mb-0.5">Sponsored</p>
          <p className="text-slate-300 text-sm font-semibold">Grow your portfolio with smarter tools</p>
          <p className="text-fg-subtle text-xs mt-0.5">Upgrade to Pro for real-time alerts, advanced screeners, and more.</p>
        </div>
        <a
          href="/account"
          className="flex-shrink-0 text-xs font-semibold text-amber-400 border border-amber-500/40 hover:border-amber-400/70 hover:text-amber-300 px-4 py-2 rounded-lg transition-colors"
        >
          Upgrade
        </a>
      </div>
    </div>
  );
}
